import { html, customElement } from '@adobe/edex/ui/edex-lit';
import { DialogHeadingClassName, EdexTagName } from '@adobe/edex/ui/shared/constants';
import { BaseElement } from '@adobe/edex/ui/components/base.element';
import { Overlay } from '@spectrum-web-components/overlay';
import { getAssetURL } from '@adobe/edex/ui/shared/utils';
import { isEmpty } from 'lodash';
import '@spectrum-web-components/dialog/sp-dialog-wrapper.js';

import(
  /* webpackChunkName: "component/resource-delete-dialog-styles" */
  /* webpackPreload: true */
  /* webpackMode: "lazy" */
  './import-result-dialog.scss'
);
@customElement(EdexTagName.importResultDialog)
export class Dialog extends BaseElement {
  static get properties() {
    return {
      dismissable: { type: Boolean },
      divider: { type: Boolean },
      headingClassName: { type: String },
      totalAttempted: { type: Number },
      successCount: { type: Number },
      errorCount: { type: Number },
      showErrorLogInfo: { type: Boolean },
      reportUrl: { type: String },
    };
  }
  dismissable = false;
  divider = false;
  headingClassName = DialogHeadingClassName.default;
  closeOverlay: any;
  totalAttempted = 0;
  successCount = 0;
  errorCount = 0;
  showErrorLogInfo = false;
  reportUrl = '';

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('sp-closed', this.emitCloseEvent);
  }

  disconnectedCallback() {
    this.closeOverlay?.();
    this.removeEventListener('sp-closed', this.emitCloseEvent);
    super.disconnectedCallback();
  }

  async firstUpdated() {
    await this.openOverlay();
    if (!isEmpty(this.reportUrl)) {
      this.downloadEnrollmentReport(this.reportUrl);
    }
  }

  openOverlay = async () => {
    const interaction = 'modal';
    const content = this.shadowRoot.querySelector('sp-dialog-wrapper') as any;

    this.shadowRoot.querySelectorAll('slot').forEach((slot) => {
      const nodes = [...slot.assignedNodes({ flatten: true })];
      if (nodes.length) {
        content.querySelector(':first-child').appendChild(...nodes);
      }
    });

    const options = {
      offset: 0,
      placement: 'none',
      receivesFocus: 'auto',
    };
    this.closeOverlay = await Overlay.open(this, interaction, content, options as any);
  };

  emitCloseEvent = () => {
    this.emitEvent('close');
  };

  downloadEnrollmentReport(reportUrl) {
    const fileLink = document.getElementById('downloadEnrollmentUpdateReportHiddenAnchor') as HTMLAnchorElement;
    fileLink.href = reportUrl;
    fileLink.click();
  }

  renderDownloadedInfo() {
    return this.showErrorLogInfo
      ? html`
          <p class="error-log-info">Report is downloaded</p>
        `
      : null;
  }

  renderSuccessCount() {
    const { successCount } = this;
    return html`
      <div>
        <img class="status-icon-image" src=${getAssetURL('file-import-success.png')} />
        <p>${successCount} successfully passed</p>
      </div>
    `;
  }

  renderWithErrorCount() {
    const { successCount, errorCount } = this;
    return html`
      <div class="import-success">
        <div class="image-text-container">
          <img class="status-icon-image" src=${getAssetURL('file-import-success.png')} />
          <p>${successCount} successfully passed</p>
        </div>
      </div>
      <div class="vertical-line"></div>
      <div class="image-text-container">
        <img class="status-icon-image" src=${getAssetURL('file-import-fail.png')} />
        <p>${errorCount} errors found</p>
        ${this.renderDownloadedInfo()}
      </div>
    `;
  }

  render() {
    const { totalAttempted, dismissable, divider, headingClassName, errorCount } = this;
    return html`
      <overlay-trigger>
        <sp-dialog-wrapper
          underlay
          ?dismissable=${dismissable}
          ?no-divider=${!divider}
          ?responsive=${true}
          @close=${this.emitCloseEvent}
          headingClass=${headingClassName}
          .divider=${false}
        >
          <h2 class="import-header-msg">Attempted to pass ${totalAttempted} students</h2>
          <div class="import-dialog">${errorCount > 0 ? this.renderWithErrorCount() : this.renderSuccessCount()}</div>
          <a id="downloadEnrollmentUpdateReportHiddenAnchor" href="" hidden></a>
        </sp-dialog-wrapper>
      </overlay-trigger>
    `;
  }
}
